import React from 'react';
import commonStyles from '../Point.module.scss';
import Title from '../../shared/Title/Title';
import ReportsTable from './Table/Table';
import Filters from './Filters/Filters';
import { useSelector } from 'react-redux';
import ContentSpinner from '../../shared/Spinner/Spinner';
import { getTranslation } from '../../../utils/translation';

const Reports = () => {
    const { generalBalance, loading } = useSelector(state => state.reports);

    return (
        <>
            <Title title={getTranslation('title.reports')} />
            <Filters />
            <main className={commonStyles.main}>
                {loading ? <ContentSpinner /> : <ReportsTable data={generalBalance} />}
                {/*<ReportsTablePrint data={generalBalance} ref={reportsRef} />*/}
            </main>
        </>
    );
};

export default Reports;
